import { render, staticRenderFns } from "./mandatory-comment-pdp.vue?vue&type=template&id=d1e1ca28&"
import script from "./mandatory-comment-pdp.vue?vue&type=script&lang=js&"
export * from "./mandatory-comment-pdp.vue?vue&type=script&lang=js&"
import style0 from "./mandatory-comment-pdp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports